import React from "react";
import ContentLoader from "react-content-loader";

function CommentsLoading() {
  return (
    <ContentLoader
      speed={2} // 속도
      // width={530}
      // height={180}
      viewBox="0 0 500 70"
      backgroundColor="#27292d" // 배경색
      foregroundColor="#4b4b4b" // 요소 색
    >
      <rect x="30" y="14" rx="3" ry="3" width="300" height="20" />
      <rect x="30" y="40" rx="3" ry="3" width="400" height="20" />
    </ContentLoader>
  );
}

export default CommentsLoading;
